import Header from './component/header/Header';
import { ViProvider } from './context/ViContext';
import { MapProvider } from './context/MapContext';
import TabMenu from './component/Tab/TabMenu';
import MapWrapper from './component/map/MapWrapper';
import { useEffect } from 'react';
import axios from 'axios';

function createVisitorLog() {
	axios({
		method: 'GET',
		url:
			process.env.REACT_APP_CONTEXT_PATH +
			'/interactive/api/visitor/log.json?item_cd=vit',
	});
}

function App() {
	useEffect(() => {
		createVisitorLog();
	}, []);

	return (
		<ViProvider>
			<MapProvider>
				<Header />
				<TabMenu />
				<MapWrapper />
			</MapProvider>
		</ViProvider>
	);
}

export default App;
